import SimpleForm from './simpleForm'

export default SimpleForm